module.exports = __webpack_public_path__ + "static/media/logoconfiax.3eb7abdd.svg";